<template lang="pug">
  .action-panel
    .action-panel__info Выбрано {{count}}
    button.button.action-panel__button(
    @click="action(2)"
    ) Взять в работу
    // button.button.action-panel__button(
    // @click="action(4)"
    // ) Перевести в резерв
    button.button.action-panel__button(
    @click="action(5)"
    ) Отклонить
</template>

<script>
export default {
  name: "table-actions",
  props: ["count"],
  methods: {
    action(status) {
      this.$emit("on-button-click", status);
    },
  },
};
</script>
